import React from "react";
import { motion } from "framer-motion";

export const ArtistFirst = () => {
    return (
        <section
            id="artists"
            className="relative py-32 lg:py-44 overflow-hidden"
            data-testid="artist-first-section"
        >
            <div className="absolute inset-0 grain pointer-events-none" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#791EE2] opacity-15 blur-[180px] pointer-events-none pulse-glow" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9 }}
                    className="max-w-5xl"
                >
                    <p className="text-sm uppercase tracking-[0.3em] text-[#F54815] mb-6 font-medium">
                        Artists empowered
                    </p>
                    <h2
                        className="font-heading text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-extrabold tracking-tighter leading-[0.95] mb-10"
                        data-testid="artist-first-heading"
                    >
                        <span className="text-white">Built for </span>
                        <span className="gradient-text">artists.</span>
                        <br />
                        <span className="text-white">Designed for </span>
                        <span className="text-[#791EE2]">scale.</span>
                    </h2>

                    <div className="grid md:grid-cols-2 gap-10 lg:gap-16 max-w-4xl">
                        <p className="text-lg lg:text-xl text-white/65 leading-relaxed font-body">
                            No labels. No gatekeepers. No surprise contracts.
                            You keep <span className="text-white font-semibold">100% of your masters</span>, full
                            ownership of your catalog and complete creative
                            control — always.
                        </p>
                        <p className="text-lg lg:text-xl text-white/65 leading-relaxed font-body">
                            The same infrastructure that powers chart-topping
                            independents, made available to every artist with
                            something to say. <span className="text-white font-semibold">Your sound. Your terms.</span>
                        </p>
                    </div>

                    {/* signature numbers */}
                    <div className="mt-20 grid grid-cols-3 gap-8 border-t border-white/10 pt-12">
                        {[
                            { v: "100%", l: "Rights retained" },
                            { v: "0%", l: "Long-term lock-ins" },
                            { v: "24h", l: "Royalty visibility" },
                        ].map((s) => (
                            <div key={s.l} data-testid={`stat-${s.l.replace(/\s/g, "-")}`}>
                                <div className="font-heading text-4xl lg:text-5xl font-bold text-white">
                                    {s.v}
                                </div>
                                <div className="text-sm text-white/50 mt-2">
                                    {s.l}
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
